<template>
  <div class="legend-container caption my-2">
    <div
      v-for="item in items"
      :key="item.label"
      class="legend-item"
      :class="{ rtl: $vuetify.rtl }"
    >
      <svg :width="symbolSize" :height="symbolSize" class="legend-swatch">
        <rect
          v-if="item.shape === 'square'"
          :x="symbolSize * 0.05"
          :y="symbolSize * 0.05"
          :width="symbolSize * 0.9"
          :height="symbolSize * 0.9"
          :fill="item.color"
        ></rect>
        <circle
          v-if="item.shape === 'circle'"
          :cx="symbolSize / 2"
          :cy="symbolSize / 2"
          :r="symbolSize / 2"
          :fill="item.color"
        ></circle>
        <polygon
          v-if="item.shape === 'triangle'"
          :points="
            `0,${symbolSize} ${symbolSize},${symbolSize} ${symbolSize / 2},0`
          "
          :fill="item.color"
        ></polygon>
      </svg>
      <h2 v-if="title" class="legend-label" :class="{ rtl: $vuetify.rtl }">
        {{ item.label }}
      </h2>
      <div v-else class="legend-label" :class="{ rtl: $vuetify.rtl }">
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    title: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      symbolSize: 16
    };
  }
};
</script>

<style scoped>
.legend-container {
  display: flex;
  flex-flow: row wrap;
}

.legend-item {
  display: flex;
  align-items: center;
}

.legend-item + .legend-item {
  margin-left: 16px;
  margin-right: 0;
}

.legend-item.rtl + .legend-item.rtl {
  margin-left: 0;
  margin-right: 16px;
}

.legend-label {
  margin-left: 4px;
  margin-right: 0;
}

.legend-label.rtl {
  margin-left: 0;
  margin-right: 4px;
}
</style>